if (typeof active_affiliate !== 'undefined') {
  const announcement_bar = document.querySelector("#announcement__slider")

  if (announcement_bar) {
    const slideContainer = document.createElement("div")
    slideContainer.className = "keen-slider__slide"

    const affiliate_msg = document.createElement("h6")
    affiliate_msg.className = "announcement-bar__message announcement-bar__message--affiliate mobile--smaller"

    const parts = active_affiliate.msg.split("_code_")

    const link = document.createElement("a")
    link.href = "/collections/" + active_affiliate.collection_handle 
    link.classList.add("announcement-bar__message--affiliate"); 
    link.appendChild(document.createTextNode(parts[0]))
    affiliate_msg.appendChild(link);

    const discountCode = document.createElement("span");
    discountCode.classList.add("textToCopy"); 
    discountCode.textContent = active_affiliate.discount_code // the actual code instead of _code_
    affiliate_msg.appendChild(discountCode);
    discountCode.addEventListener('click', function (e) {
      let textToCopy = e.target.innerText;
      copyToClipboard(textToCopy);
    });


    if (parts[1]) { 
      const link2 = document.createElement("a")
      link2.href = "/collections/" + active_affiliate.collection_handle 
      link2.classList.add("announcement-bar__message--affiliate"); 
      link2.appendChild(document.createTextNode(parts[1]))
      affiliate_msg.appendChild(link2);
    }
    
    slideContainer.appendChild(affiliate_msg)
    announcement_bar.insertBefore( slideContainer,  announcement_bar.children[1] || null );
    window?.announcementSlider.update();

    // set a new cookie expires after 7 days for the new message
    if (getCookie('affiliate_announcement') != slideContainer.outerHTML) {
      setCookie('affiliate_announcement',  slideContainer.outerHTML, 7)
    }

  }
}


if (window.location && window.location.href && window.location.href.includes('/collections/tall-collection')) {
  let tallPopupSignup = document.querySelector('.vertical-popup-signup--tall');
  
  // Check if popup already shown this session
  let alreadyShown = sessionStorage.getItem('tallPopupShown') === 'true';
  
  if (alreadyShown && tallPopupSignup) {
    // If already shown, make button visible immediately
    tallPopupSignup.classList.remove("hidden");
  } else {
    // auto-open tall popup after 10s on tall collection page (once per session)
    setTimeout(function() {
      openPopup('Rcq94G', 'tallPopupShown', true);
      if (tallPopupSignup) {
        tallPopupSignup.classList.remove("hidden")
      }
    }, 10000);
  }

  // floating corner button to open tall popup only on tall collection page
  if (tallPopupSignup) {
    tallPopupSignup.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('Rcq94G', 'tallPopupShown', false);
    });
  }
}else if (window.location && window.location.href && window.location.href.includes('/collections/') && window.location.href.includes('petite') ) {
  let petitePopupSignupDesktop = document.querySelector('.vertical-popup-signup--petite-desktop');
  let petitePopupSignupMobile = document.querySelector('.vertical-popup-signup--petite-mobile');
  
  // Check if popup already shown this session
  let alreadyShown = sessionStorage.getItem('petitePopupShown') === 'true';
  
  if (alreadyShown) {
    // If already shown, make buttons visible immediately
    if (petitePopupSignupMobile) {
      petitePopupSignupMobile.classList.remove("hidden");
    }
    if (petitePopupSignupDesktop) {
      petitePopupSignupDesktop.classList.remove("hidden");
    }
  } else {
    // auto-open petite popup after 10s on petite collection page (once per session)
    setTimeout(function() {
      // Check if screen width is less than small breakpoint (749px)
      if (window.innerWidth < 749) {
        openPopup('RGFxX9', 'petitePopupShown', true); // Mobile popup
      } else {
        openPopup('V34hTz', 'petitePopupShown', true); // Desktop popup
      }
      if (petitePopupSignupMobile) {
        petitePopupSignupMobile.classList.remove("hidden")
      }
      if (petitePopupSignupDesktop) {
        petitePopupSignupDesktop.classList.remove("hidden")
      }
    }, 10000);
  }

  // floating corner button to open petite popup
  if (petitePopupSignupDesktop) {
    petitePopupSignupDesktop.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('V34hTz', 'petitePopupShown', false);
    });
  }
  if (petitePopupSignupMobile) {
    petitePopupSignupMobile.addEventListener('click', function(e) {
      console.log('petitePopupSignupMobile clicked');
      e.preventDefault();
      openPopup('RGFxX9', 'petitePopupShown', false);
    });
  }
}

function openPopup(popupId = 'Rcq94G', sessionKey = null, checkSession = true) {
  // Check if popup has already been shown this session (only for auto-open)
  if (checkSession && sessionKey && sessionStorage.getItem(sessionKey) === 'true') {
    return;
  }
  
  // ensures Klaviyo is initialized and has time to reset between opens
  if (window._klOnsite && typeof window._klOnsite.push === 'function') {
    setTimeout(() => {
      window._klOnsite.push(['openForm', popupId]);
      // Mark as shown in session storage
      if (sessionKey) {
        sessionStorage.setItem(sessionKey, 'true');
      }
    }, 200);
  } else {
    console.warn('Klaviyo not ready yet — retrying...');
    setTimeout(() => openPopup(popupId, sessionKey, checkSession), 500);
  }
}
